import ASegment from './Segment.vue';
export default ASegment;


// WEBPACK FOOTER //
// ./src/packages/Segment/index.js